import { Stack } from '@mui/material';
import { Fragment, ComponentType } from 'react';
import AutoTrackingMilesightsCameraPTZ from './components/AutoTrackingMilesightsCameraPTZ';
import BasicInfoMilesightCameraPTZ from './components/BasicInfoMilesightCameraPTZ';
import DateAndTimeMilesightsCameraPTZ from './components/DateAndTimeMilesightsCameraPTZ';
import ImageGeneralMilesightsCameraPTZ from './components/ImageGeneralMilesightsCameraPTZ';
import InitialPositionMilesightsCameraPTZ from './components/InitialPositionMilesightsCameraPTZ';
import MotionDetectionMilesightsCameraPTZ from './components/MotionDetectionMilesightsCameraPTZ';
import PTZ_LimitsMilesightsCameraPTZ from './components/PTZ_LimitsMilesightsCameraPTZ';
import StorageMilesightsCameraPTZ from './components/StorageMilesightsCameraPTZ';
import VideoMilesightsCameraPTZ from './components/VideoMilesightsCameraPTZ';
import { SectionsCollapsePTZ } from '@pages/cameras/hook/useMilesightPTZ';

interface SectionProps {
    isOpenCollapse: { [key in SectionsCollapsePTZ]: boolean };
    handleToggleCollapse: (section: SectionsCollapsePTZ) => void;
    onSyncPTZConfigs?: () => void;
}

type SectionComponent = ComponentType<SectionProps>;

const sections: SectionComponent[] = [
    BasicInfoMilesightCameraPTZ,
    PTZ_LimitsMilesightsCameraPTZ,
    InitialPositionMilesightsCameraPTZ,
    AutoTrackingMilesightsCameraPTZ,
    VideoMilesightsCameraPTZ,
    ImageGeneralMilesightsCameraPTZ,
    StorageMilesightsCameraPTZ,
    MotionDetectionMilesightsCameraPTZ,
    DateAndTimeMilesightsCameraPTZ,
];

type Props = {
    isOpenCollapse: { [key in SectionsCollapsePTZ]: boolean };
    handleToggleCollapse: (section: SectionsCollapsePTZ) => void;
    onSyncPTZConfigs?: () => void;
};

export default function MileSightPtzPage({ isOpenCollapse, handleToggleCollapse, onSyncPTZConfigs }: Props) {
    return (
        <Stack width="100%" direction="column" spacing={2}>
            {sections.map((Component, index) => (
                <Fragment key={index}>
                    <Component
                        isOpenCollapse={isOpenCollapse}
                        handleToggleCollapse={handleToggleCollapse}
                        onSyncPTZConfigs={onSyncPTZConfigs}
                    />
                </Fragment>
            ))}
        </Stack>
    );
}
